<!--
HS코드 선택기 > 상품정보 수정에서 사용하는 모듈
-->
<template>
    <div class="app-prod-hscode-on-edit">
        <div class="uk-flex uk-flex-left uk-flex-bottom">
            <div style="width: 80px">
                <app-input-ex
                        class="input"
                        type="text"
                        input-size="medium"

                        :name="name"
                        :value="value"
                        @update:value="val => $emit('update:value', val)"
                        label="HS코드"
                > </app-input-ex>
            </div>

            <div class="uk-width-expand">
                <multiselect
                        @input="updateValue"
                        :options="hscodeOptions"
                        label="text"

                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        placeholder="품목명으로 검색하세요"
                >
                    <!-- 현재 선택값 표현 -->
                    <template
                            slot="singleLabel"
                            slot-scope="{ option }"
                    >
                        {{ option.text }}
                    </template>

                    <!-- 검색결과없음 표현 -->
                    <template slot="noResult">
                        Not found element
                    </template>

                    <!-- 옵션목록 > 옵션한개 표현 -->
                    <template slot="option" slot-scope="{ option }">
                        {{ option.text }}
                    </template>

                </multiselect>
            </div>


        </div>


        <div v-nl2br="selectedFullname" class="selected-fullname">
        </div>

        <div class="detail-search">
            <div class="border-box uk-padding-small uk-text-left">
                <i class="material-icons">info</i>
                위 목록에서 검색되지 않는 품목은 상세검색 후 6자리 코드를 직접입력하세요.
                <div class="uk-flex uk-flex-between uk-margin-small-top">
                    <a href="https://www.bandtrass.or.kr/hsnavi.do?page=F&site=#table_content" class="uk-button uk-button-primary uk-button-small" target="_blank">
                        <i class="material-icons">forward</i>
                        HS코드 상세검색
                    </a>

                    <a href="https://global.gonelo.com/common/faqs/170" target="_blank" class="uk-button uk-button-small uk-button-dark">
                        자세히읽기<i class="material-icons">open_in_new</i>
                    </a>
                </div>

            </div>

        </div>



    </div>




</template>

<script>
    import Multiselect from "vue-multiselect";

    export default {
        components: {Multiselect},
        // v-model 처리
        model: {
            prop: 'value',
            event: 'update:value'
        },
        props: {
            name: String,
            /**
             * input 요소의 값
             */
            value: {
                type: [String, Number],
                default: ''
            },

            /**
             * hs코드 옵션배열
             */
            hscodeOptions: {
                type: Array,
                default: () => {return [];}
            },

            /**
             * hs코드(코드별 전체품목) 옵션배열
             */
            hscodefullOptions: {
                type: Array,
                default: () => {return [];}
            },

        },
        data: function () {
            return {

            };
        },
        computed: {

            /**
             * 현재 입력된 hs코드 대한 모든 품목명
             * @return object
             */
            selectedFullname() {
                let opt = _.find(this.hscodefullOptions, (option) => {
                    return this.value == option.val;
                });

                if (opt) {
                    return opt.text;
                }

                return null;

            },

        },
        methods: {

            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param event vue 이벤트 객체
             * */
            updateValue: function (event) {
                // vue-multiselect 에서 이벤트가 발생한 경우에는 인자값으로 선택값이 바로 옴.
                this.$emit('update:value', event.val);

            },

        },


    }
</script>


<!-- 멀티셀렉트 요소에 스타일을 적용하기 위해서 scoped 적용안함 -->
<style lang="scss">
.app-prod-hscode-on-edit {
  .selected-fullname {
    color: #333;
//    padding-left: 105px;
  }
  .detail-search {
    margin-top: 15px;
//    padding-left: 105px;
  }
    .guide {
        margin-top: 15px;
    }

  .multiselect {
    height: 32px !important;
    min-height: 32px !important;
  }

  .multiselect__select {
    height: 32px !important;
    min-height: 32px !important;
  }
  .multiselect__tags {
    height: 32px !important;
    min-height: 32px !important;
    padding: 2px 2px 0 10px !important;
  }
  .multiselect__content {
    padding-left: 10px !important;
  }
  .multiselect__option {
    height: 32px !important;
    min-height: 32px !important;
    padding: 4px !important;
  }
}

</style>